module.exports = __webpack_public_path__ + "static/media/music.4f12f46d.svg";